<template>
	<page>
		<module title="多件优惠购活动详情">
			<div v-if="activityInfo">
				<c-detail title="基础信息">
					<c-detail-item label="活动名称">{{activityInfo.activity_name}}</c-detail-item>
					<c-detail-item label="活动时间">{{activityInfo.start_time}} - {{activityInfo.end_time}}</c-detail-item>
					<c-detail-item label="活动标签">{{activityInfo.tags}}</c-detail-item>
                    <c-detail-item label="可售范围">{{activityInfo.visible_user_level_name}}</c-detail-item>
                </c-detail>
                <c-detail title="优惠配置">
                    <c-detail-item label="是否循环计算">
                        <span v-if="activityInfo.cycle_rule==1">
                            循环计算优惠
                        </span>
                        <span v-else>
                            不循环
                        </span>
                    </c-detail-item>
                    <c-table v-model="ruleList" height="auto" border style="margin-top: 10px;">
                        <c-table-column
                                label="第X件"
                                name="step_seq"
                                width="60"
                        >
                            <template v-slot="{data}">
                                第{{data.step_seq}}件
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="权益类型"
                                name="benefit_type"
                                width="160"
                        >
                            <template v-slot="{data}">
                                <span v-if="data.benefit_type == 1">
                                    固定金额
                                </span>
                                <span v-if="data.benefit_type == 2">
                                    指定折扣
                                </span>
                                <span v-if="data.benefit_type == 3">
                                    不打折
                                </span>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="权益值"
                                name="benefit_value"
                                width="140"
                        >
                            <template v-slot="{data}">
                                <span v-if="data.benefit_type == 1">
                                    ￥{{data.benefit_value}}
                                </span>
                                <span v-if="data.benefit_type == 2">
                                    {{data.benefit_value}}折
                                </span>
                                <span v-if="data.benefit_type == 3">
                                    不打折
                                </span>
                            </template>
                        </c-table-column>
                    </c-table>
                </c-detail>
                <c-detail title="活动商品">
                    <c-table v-model="productList" height="auto" border>
                        <c-table-column
                            label="商品信息"
                            name="product_name"
                            width="200"
                        >
                            <template v-slot="{data}">
                                <div class="flex-center">
                                    <c-image :src="oss(data.product_img_url, 46, 46)" size="46" preview></c-image>
                                    <p class="flex-grow ellipsis-2" style="margin-left: 12px;">{{data.product_name}}</p>
                                </div>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="所属类目"
                                name="product_type_full_name"
                        ></c-table-column>

                        <c-table-column
                            label="价格"
                            name="product_price"
                            width="80"
                        >
                            <template v-slot="{data}">￥{{data.product_price}}</template>
                        </c-table-column>

                        <c-table-column
                            label="库存"
                            name="stock_count"
                            width="80"
                        ></c-table-column>
                    </c-table>
				</c-detail>
			</div>
            <template slot="button">
                <c-button size="m" @click="closeCurrPage()">关闭</c-button>
            </template>
		</module>
  </page>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		name: 'activity_tp_detail',
		
		props: {
			id: String
		},
		
		data() {
			return {
				activityInfo: '',
				productList: [],
                ruleList: []
			}
		},
		
		computed: {
			...mapState(['dict'])
		},
		
		watch: {
			id() {
				this.getActivityDetail();
			}
		},
		
		mounted() {
			this.getActivityDetail();
		},
		
		methods: {
			getActivityDetail() {
				this.request({
					url: '/activityTp/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.activityInfo = data;
                        this.ruleList = data.rule_list;
						this.productList = data.product_list;
					}
				});
			},
            closeCurrPage() {
                    this.redirectTo('/activity_tp_list');
            }
		}
	}
</script>